export default __webpack_public_path__ + "static/media/tuple.2648bdbb.mjs";